// @flow
'use strict';

import { connect } from 'react-redux';

import BotaoOpcaoConfirmada from './botao_opcao_confirmada';

export default connect<*, *, *, *, *, *>()(BotaoOpcaoConfirmada);
